import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectIsEncumbranceRealty = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('is_encumbrance_realty')(jsonQuery),
);
